const assistLoginForm = $('#assist-login-form');
const assistantNameError = $('.assistant-name-error');
const assistantPhoneError = $('.assistant-phone-error');
const assistantOtpError = $('.assistant-otp-error');
const assistantEmailError = $('.assistant-email-error');
const assistantLoginName = $('#assist_login_name');
const assistantLoginPhone = $('#assist_login_phone');
const submitAssistant = $('#submitAssistant');
let assistantUserData = {};
let getCityStateDataByAddressData = {};
const bodySelector = $('body');

window.parentData = {
    "school_type": "",
    "school_type_id": "",
    "grade": "",
    "fees": [],
    "board": [],
    "region": [],
    "age": "",
    "fee_range": []
};

let stepJson = {
    "day": {
        "grade": {
            "Pre Nursery": ["16", "16"],
            "Nursery": ["1", "1"],
            "Class 1": ["3", "3"],
            "Class 2": ["4", "4"],
            "Class 3": ["5", "5"],
            "Class 4": ["6", "6"],
            "Class 5": ["7", "7"],
            "Class 6": ["8", "8"],
            "Class 7": ["9", "9"],
            "Class 8": ["10", "10"],
            "Class 9": ["11", "11"],
            "Class 10": ["12", "12"],
            "Class 11": ["13", "13"],
            "Class 12": ["14", "14"]

        },
        "fees": {
            "< 30K": ["fee-<30000", "500-30000"],
            "30K to 50K": ["fee->30000_<50000", "30000-50000"],
            "50K to 70K": ["fee->50000_<70000", "50000-70000"],
            "70k to 1Lac": ["fee->70000_<100000", "70000-100000"],
            "1 Lac to 2 Lac": ["fee->100000_<200000", "100000-200000"],
            "> 2 Lac": ["fee->200000", "200000-1000000"]
        },
        "board": {
            "CBSE": ["board-1", "1"],
            "ICSE/ISC": ["board-2", "2"],
            "IB": ["board-3", "3"],
            "IGCSE": ["board-6", "6"],
            "State Board": ["board-5", "5"],
            "Other": ["board-4", "4"]
        }
    },
    "pre": {
        "age": {
            "< 1Year": ["<1year", "12"],
            "1Year to 2Year": ["1to2", "18"],
            "2Year to 3Year": ["2to3", "30"],
            "> 3Year": [">3year", "36"]

        },
        "fees": {
            "< 2.5K": ["fee-<2500", "500-2500"],
            "2.5K to 5K": ["fee->2500_<5000", "2500-5000"],
            "5K to 8K": ["fee->5000_<8000", "5000-8000"],
            "> 8K": ["fee->8000", "8000-100000"]
        }
    }
};

$('#openAssistantModal').on('click', function () {
    checkSmartSearchLogin();
    $('.modal-backdrop').hide();
});

window.AssistUserAge = (age) => {
    function monthDiff(d1, d2) {
        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        selectMonth(months);
        return months <= 0 ? 0 : months;
    }

    let date1 = age.replace(/-/g, ',');
    let d = new Date();
    let today = d.getFullYear() + "," + (d.getMonth() + 1) + "," + d.getDate();

    monthDiff(new Date(date1), new Date(today));

    function selectMonth(months) {
        if (months <= "12") $('#ageFilter span[data-age ="12"]').addClass('active-assist');
        else if (months > "12" && months <= "18") $('#ageFilter span[data-age ="18"]').addClass('active-assist');
        else if (months > "18" && months <= "30") $('#ageFilter span[data-age ="30"]').addClass('active-assist');
        else if (months > "30" && months <= "36") $('#ageFilter span[data-age ="36"]').addClass('active-assist');
    }
}

window.AssistFinish = () => {
    if (user) {
        //getPrefLoc();

        // let Type = $('input[name="school_type"][checked="checked"]').val();
        let Type = $('#AssistantModal .school-selector.selected').attr('data-schooltypeid');

        submitAssistant.css('pointer-events','none').html(`Loading <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>`);

        /*if(!submitAssistant.is(':visible')){
                $('#FinishAssistant').prop('disabled', true).hide();
                $(`<button class="btn btn-success finish-btns" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                </button>`).insertAfter('#FinishAssistant');
        }*/

        assistantSubmitOnLogin();
        // $('#AssistantModal').modal('hide');

    } else {
        assistantLoginPhone.focus();
        $('.errorFinish').html('Please Login to continue ');
    }
}

window.AssistUserSchoolType = (type) => {
    // if (DEBUG) console.log('AssistUserSchoolType');
    // $('input[name="school_type"][value=' + type + ']').click();
    $(`#AssistantModal .school-selector[data-schooltypeid=${type}]`).trigger('click');
}

window.AssistUserfees = (fees) => {
    // debugger;
    if (fees === null) return;
    const assistFeeSlider = $('.assist-fee-slider').data("ionRangeSlider");
    let feeBands = [];

    // assistFeeSlider.update({min, max});

    fees.split(',')
        .forEach((fee) => {
            feeBands.push(...fees.split('-'));
            $(`#AssistantModal .assistant-fees-wrapper .assistant-tag[data-filter=${fee}]`).trigger('click');
        });
    let feeMin = Math.min(...feeBands);
    let feeMax = Math.max(...feeBands);

    assistFeeSlider.update({from: feeMin, to: feeMax});
}

window.ageOneSelect = () => {
    $('#ageFilter span.assist-tag').click(function () {
        $(this).addClass('active-assist');
        $(this).siblings().removeClass('active-assist');
    })
}

window.gradeOneSelect = ()=> {
    $('#filter_grade span.assist-tag').click(function () {
        $(this).addClass('active-assist');
        $(this).siblings().removeClass('active-assist');
    });
}

window.setTextSchool = (type) => {
    type = parseInt(type);
    if (type === 1) {
        $('.school-type-text').text('Day School');
    } else if (type === 2) {
        $('.school-type-text').text('Play School');
    } else if (type === 5) {
        $('.school-type-text').text('PU School');
    } else {
        $('.school-type-text').text('Boarding School');
    }
}

window.assistRegionText = () => {
    let regionstext = [];
    $('#regionFilter').find('span.assist-tag.active-assist').each(function () {
        regionstext.push($(this).text());
    });
    let assistRegionTextStr = regionstext.join(',');
    $('.region-text').text(assistRegionTextStr);

}

window.gradeText = ()=> {
    let gradeTextStr = $('#gradeFilter').find('span.assist-tag.active-assist').text();
    $('.grade-text').text(gradeTextStr);

}

window.feestext = ()=> {
    let feetext = [];
    $('#feeFilter').find('span.assist-tag.active-assist').each(function () {
        feetext.push($(this).text());
    });

    let assistfeetext = feetext.join(' and ');
    $('.fees-text').text(assistfeetext);

}

window.boardstext = ()=> {
    let boardstext = [];
    $('#filter_board').find('span.assist-tag.active-assist').each(function () {
        boardstext.push($(this).text());
    });
    let assistboardtext = boardstext.join(',');
    $('.board-text').text(assistboardtext);
}

window.agetext = ()=> {
    let agetext = $('#ageFilter').find('span.assist-tag.active-assist').text();
    $('.age-text').text(agetext);
}

window.AssistUserPuQueryText = () => {
    boardstext();
    feestext();
}

window.locality = (address) => {
    $('#preferred-locality').val(address);
}

window.AssistUserPreQueryText = () => {
    agetext();
    feestext();
}

window.AssistUserBoardingQueryText = () => {
    gradeText();
    boardstext();
    feestext();
    assistRegionText();
}

window.getGender = (gender) => {
    if (gender === 'male,co-ed') $('input[name="gender"][value="male,co-ed"]').prop('checked', true);
    else if (gender === 'female,co-ed') $('input[name="gender"][value="female,co-ed"]').prop('checked', true);
}

window.AssistUserGrade = (grade) => {
    if (grade === null) return;
    $(`#AssistantModal .assistant-grade-wrapper .assistant-tag[data-filter=${grade}]`).trigger('click');
}

window.AssistUserBoard = (boards) => {
    if (boards === null) return;
    boards.split(',')
        .forEach((board) => $(`#AssistantModal .assistant-board-wrapper .assistant-tag[data-filter=${board}]`)
            .trigger('click'));

}

window.AssistUserRegion = (regions) => {
    if (regions === null) return;
    regions.split(',')
        .forEach((region) => $(`#AssistantModal .assistant-region-wrapper .assistant-tag[data-filter=${region}]`)
            .trigger('click'));
}

window.assistantSubmitOnLogin = () => {
    /*if (justSubmitted) return;
     justSubmitted = true;*/
    // debugger;
    showLoaderCoverAssist();

    let data = {
        place_name: $('#preferred-locality').val(),
        // location_type: location_type,
        lat: $('#preferred-latitude').val(),
        lng: $('#preferred-longitude').val(),
        label: $('input[name=prefOpt]:checked').val()
    };
    if (DEBUG) console.log('submitting tracking data', data);

    if (data.lat === "" || data.lng === "" || data.place_name === "") {
        //when empty use get ip geolocation lat long constant defined in prefered loaction.php
        data.lat = latitude;
        data.lng = longitude;
        data.place_name = cityName;
    }

    mainApiAxios.post('/update-user-tracking', data).then(res => {
        AssistSubmit();

    }).catch(err => {
        console.log(err);
        const errorId = $('#pref_location_error');
        errorId.text('').text("please try again failed to set Preferred location.");
    })

    /*$.ajax({
        type: "POST",
        url: `${HOST}/users/user_track/user_track_insert_or_update.php`, /!* users/user_track/user_track_insert.php replaced *!/
        data: data,
        success: (response) => {
            response = response ? response.toString() : "null";

            if (response.trim() !== "null") {

                //$('#AssistantModal').modal('hide');
                $('#pref_location_error').text('');
                AssistSubmit();
                // getPrefLoc();
            } else {
                $('#pref_location_error').text("please try again failed to set Preferred location.");
            }
            hideLoaderCoverAssist();
        }
    });*/
}

window.AssistSubmit = () => {
    if (user) {
        // debugger;
        /* Sending analytics value */
        // let assistSchoolType = $('input[name="school_type"][checked="checked"]').val();
        let assistSchoolType = parseInt($('#AssistantModal .school-selector.selected').attr('data-schooltypeid'));

        if (assistSchoolType === 1) {
            AssistantAnalyticsDaySchool();
        } else if (assistSchoolType === 2) {
            AssistantAnalyticsPreSchool();
        }


        let userID = user.id;
        // let grade = $('#gradeFilter').find('span.assist-tag.active-assist').attr('data-id');
        let grade = $('#AssistantModal .assistant-grade-wrapper .assistant-tag.selected').attr('data-id');

        // FEES MULTIPLE SELECTION
        // let fee = [];
        /*$('#AssistantModal .assistant-fees-wrapper .assistant-tag.selected').each(function () {
            fee.push($(this).attr('data-filter'));
        });*/

        // let assistFee = fee.join(',');
        const assistFeeSlider = $('.assist-fee-slider').data("ionRangeSlider");
        let assistFee = `${assistFeeSlider.old_from}-${assistFeeSlider.old_to}`;


        // BOARDS
        let boards = [];
        $('#AssistantModal .assistant-board-wrapper .assistant-tag.selected').each(function () {
            boards.push($(this).attr('data-filter'));
        });
        let assistBoard = boards.join(',');

        // AGE
        let age = $('#AssistantModal .assistant-age-wrapper .assistant-tag.selected').attr('data-filter');


        // REGIONS
        let assistRegions = [];
        $('#AssistantModal .assistant-region-wrapper .assistant-tag.selected').each(function () {
            assistRegions.push($(this).attr('data-filter'));
        });
        let assistRegion = assistRegions.join(',');

        //Locality
        let locality = $('#preferred-locality').val().trim();

        let AssistLat = !!locality ? $('#preferred-latitude').val().trim() : '';
        let AssistLng = !!locality ? $('#preferred-longitude').val().trim() : '';

        let notify = $('#notification').val();

        let gender = $("input[name='gender']:checked").val();

        let user_action = '';
        if (typeof only_assistant_page === 'undefined') {
            user_action = '';
        } else {
            user_action = 'assistant_filled';
        }

        let assistantFormData = new FormData();
        assistantFormData.append('user', userID);
        assistantFormData.append('fee', assistFee);
        assistantFormData.append('school_type', assistSchoolType);
        assistantFormData.append('address', locality);
        assistantFormData.append('grade', grade ?? '');
        assistantFormData.append('region', assistRegion);
        assistantFormData.append('board', assistBoard);
        assistantFormData.append('age', age ?? '');
        assistantFormData.append('gender', gender);
        assistantFormData.append('notification', notify);
        assistantFormData.append('lead_home_location', ipCityName);
        assistantFormData.append('lead_home_lat', latitude);
        assistantFormData.append('lead_home_lng', longitude);
        assistantFormData.append('lead_lat', AssistLat);
        assistantFormData.append('lead_lng', AssistLng);
        assistantFormData.append('user_action', user_action);
        assistantFormData.append('assist', 1);

        mainApiAxios.post('/assistant-update', assistantFormData).then(res => {
            // debugger;
           /* AssistantPhoneLeadsAssignCronJob(userID, function () {
                // debugger;
                // $('.button_1O').show();
                AssistantAnalyticsSubmitted();
                insertUserAnalytics('assistant', false, 'assistant submit');
                $('.modal-backdrop').remove();

                // let searchtype = $('input[name="school_type"][checked="checked"]').val();

                schoolSearchQuery(locality, AssistLat, AssistLng, assistSchoolType, !!gender ? gender : '');

            });*/

            AssistantAnalyticsSubmitted();
            insertUserAnalytics('assistant', false, 'assistant submit');
            $('.modal-backdrop').remove();
            schoolSearchQuery(locality, AssistLat, AssistLng, assistSchoolType, !!gender ? gender : '');

        }).catch(err => console.log(err));
    }
}

window.AssistantPhoneLeadsAssignCronJob = (userId, callback) => {

    callback();

    /*$.ajax({
        url: `${HOST}/admin/lead_admin/crons/assign_phone_leads.php`,
        type: 'POST',
        data: {userid: userId},
        success: function (data) {
            if (DEBUG) console.log('success', data);
            callback(data);
        },
        error: function (data) {
            if (DEBUG) console.log('error', data);
            callback(data);
        }
    })*/

}

window.schoolSearchQuery = (PlayLoc, PlaycityLat, PlaycityLng, type, gender) =>  {
    // debugger;
    sessionStorage.removeItem('removeSearchData');
    let searchQueryPath = '';
    let genders = (gender.length && type === 3) ? gender.replace(/coed-/g, '').split(',') : '';
    let coed = [];
    let cityText = '';
    let city_name = '';
    let state_name = '';
    let coedFilters = '';

    if (genders.length) {
        genders.map((coedType, i) => {
            let coedId = coedType.replace('coed', '');
            coed.push(`coed[]=${coedId}`);
        });
    }

    if (coed.length) coedFilters += coed.join('&');

    let boards = [];
    let boardFilters = '';
    $('#AssistantModal .assistant-board-wrapper .assistant-tag.selected').each(function () {
        let boardId = $(this).attr('data-filter');
        if (boardId.length) boards.push(`board[]=${boardId}`);
    });

    if (boards.length) boardFilters += boards.join("&");

    let regions = [];
    $('#AssistantModal .assistant-region-wrapper .assistant-tag.selected').each(function () {
        let regionStr = $(this).attr('data-filter');
        regions.push(regionStr.toLowerCase());
    });

    if (regions.length) searchQueryPath += ((coed.length || boards.length) ? "-in-" : '') + regions.join("-and-") + "-region";

    let placeBaseCode = encode_decode({
        latitude: PlaycityLat,
        longitude: PlaycityLng
    });

    let address = PlayLoc.length ? slugify(PlayLoc, {lower: true}) : '';

    if(type !== 3){ // fallback when user not search in assistant
        // debugger;
        if(!assistantSchoolSearchLocationPlaces.hasOwnProperty('address_components')){
            if(!!localStorage.getItem('searchSessionDataForAssist') && !!PlayLoc){
                let searchSessionData = JSON.parse(localStorage.getItem('searchSessionDataForAssist'));
                assistantSchoolSearchLocationPlaces = searchSessionData.searchPlaceLocationData;
            }else{ // fallback for old assistant user

                if(Object.keys(assistantUserData).length && !!PlayLoc){
                    sessionStorage.setItem('removeSearchData', '1');
                    city_name = '';
                    PlaycityLat = '';
                    PlaycityLng = '';
                    if(!!assistantUserData.lead_location) address = slugify(assistantUserData.lead_location, {lower: true});
                    if(!!assistantUserData.lead_lat) PlaycityLat = assistantUserData.lead_lat;
                    if(!!assistantUserData.lead_lng) PlaycityLng = assistantUserData.lead_lng;

                    if(!!getCityStateDataByAddressData.hasOwnProperty('data')){
                        if(getCityStateDataByAddressData.data.cities.length){
                            city_name = getCityStateDataByAddressData.data.cities[0];
                        }

                        if(getCityStateDataByAddressData.data.state.length){
                            state_name = getCityStateDataByAddressData.data.state[0];
                        }
                    }

                    if(!!assistantUserData.lat && !!assistantUserData.lng){
                        placeBaseCode = encode_decode({
                            latitude: PlaycityLat,
                            longitude: PlaycityLng
                        });
                    }
                }else{ // when user didn't type location
                    // if(!!city_name) cityText = slugify(city_name);
                    sessionStorage.setItem('removeSearchData', '1');
                    city_name = '';
                    PlaycityLat = '';
                    PlaycityLng = '';
                    if(!!latitude ) PlaycityLat = latitude;
                    if(!!longitude) PlaycityLng = longitude;

                    if(!!latitude && !!longitude){
                        placeBaseCode = encode_decode({
                            latitude: PlaycityLat,
                            longitude: PlaycityLng
                        });
                    }
                }
            }
        }
    }

    let formatted_address = address;
    // debugger;
    if (!address) address = !!cityName ? slugify(cityName) : '';
    if (PlaycityLat && PlaycityLng) address += '-' + placeBaseCode.data.latlng;
    if (address.length) address += '/';

    if (type === 3) address = ''; //remove address in boarding state

   /* let dayfees = [];
    $('#AssistantModal .assistant-fees-wrapper .assistant-tag.selected').each(function () {
        dayfees.push($(this).attr('data-id'));
    });

    let Dayfee = '?Tags[]=';
    if (dayfees.length) {
        Dayfee += dayfees.length > 0 ? dayfees.join('&Tags[]=') : dayfees;
    } else {
        Dayfee = '';
    }*/
    const assistFeeSlider = $('.assist-fee-slider').data("ionRangeSlider");
    let DayFeeFilter = `feemin=${assistFeeSlider.old_from}&feemax=${assistFeeSlider.old_to}&`;



    /* search necessary data */
    let placeLevel = '';
    let localityObj = [];
    let administrativeAreaLevel1 = [];
    let administrativeAreaLevel2 = [];
    let city_2_name = '';
    let filteredFormattedAddressData = '';
    let filteredFormattedAddressDataStr = '';
    let locality = '';
    if (type !== 3) {
        if (!assistantSchoolSearchLocationPlaces.hasOwnProperty('address_components')) {
            assistantSchoolSearchLocationPlaces = JSON.parse(localStorage.getItem('searchSessionDataForAssist'));
        }

        if (!!assistantSchoolSearchLocationPlaces && assistantSchoolSearchLocationPlaces.hasOwnProperty('address_components')) {
            filteredFormattedAddressData = filterGoogleMapApiResponse(assistantSchoolSearchLocationPlaces);
            filteredFormattedAddressDataStr = filteredFormattedAddressDataSlug(assistantSchoolSearchLocationPlaces);

            localityObj = assistantSchoolSearchLocationPlaces.address_components.filter((v, i) => {
                if (v.types[0] === 'locality') return v;
            });

            administrativeAreaLevel1 = assistantSchoolSearchLocationPlaces.address_components.filter((v, i) => {
                if (v.types[0] === 'administrative_area_level_1') return v;
            });

            administrativeAreaLevel2 = assistantSchoolSearchLocationPlaces.address_components.filter((v, i) => {
                if (v.types[0] === 'administrative_area_level_2') return v;
            });
        }

        if (localityObj.length) {
            // city_name = localityObj[0].long_name.toLowerCase();
            // placeLevel = localityObj[0].types[0];
            city_name = filteredFormattedAddressData.city.toLowerCase();
        }

        if(filteredFormattedAddressData.hasOwnProperty('locality')){
            if(!!filteredFormattedAddressData.locality && filteredFormattedAddressData.locality.length){
                placeLevel = localityObj[0].types[0];
                locality = filteredFormattedAddressData.locality[filteredFormattedAddressData.locality.length - 1];
            }
        }

        if (administrativeAreaLevel2.length) {
            city_2_name = slugify(administrativeAreaLevel2[0].long_name.toLowerCase());
            // if (!placeLevel) placeLevel = administrativeAreaLevel2[0].types[0];
        }

        if (!!administrativeAreaLevel1.length) {
            // state_name = slugify(administrativeAreaLevel1[0].long_name);
            state_name = slugify(filteredFormattedAddressData.state);
            if (!placeLevel && !city_name) placeLevel = administrativeAreaLevel1[0].types[0];
        }

        /* check if city name like state name */
        /*if (!!city_name) {
            let checkCityAsStateExist = checkCityExistsInStates(city_name);
            if (checkCityAsStateExist.length) {
                city_name = "";
                city_2_name = "";
                if (!!administrativeAreaLevel1.length) placeLevel = administrativeAreaLevel1[0].types[0];
            }
        }*/

        if (pageType !== "SEO") city_2_name = "";

        let searchSessionData = {
            'locality': localityObj,
            'administrativeAreaLevel1': administrativeAreaLevel1,
            'administrativeAreaLevel2': administrativeAreaLevel2,
            'city_name': city_name,
            'city_2_name': city_2_name,
            'state_name': state_name,
            'formattedAddress': formatted_address,
            'latitude': PlaycityLat,
            'longitude': PlaycityLng,
            'placeLevel': placeLevel,
            'searchPlaceLocationData': assistantSchoolSearchLocationPlaces
        };

        localStorage.setItem('searchSessionData', JSON.stringify(searchSessionData));
        localStorage.setItem('searchSessionDataForAssist', JSON.stringify(searchSessionData));

        if(!!sessionStorage.getItem('removeSearchData')){
            localStorage.removeItem('searchSessionData')
            localStorage.removeItem('searchSessionDataForAssist');
        }

    }

   /* if (type === 3) {
        sessionStorage.setItem('homepageSearchSession', true);
    }*/

    let placeQueryData = '';

    if(!filteredFormattedAddressDataStr){
        if (!!placeLevel) placeQueryData += `&place_lavel=${placeLevel}`;
        if (!!city_name) placeQueryData += `&city_name=${slugify(city_name)}`;
        if(!!locality) placeQueryData += (city_name.length ? '&' : '') + `locality=${slugify(locality)}`;
        if ((city_name !== city_2_name) && city_2_name.length) placeQueryData += `&city_2_name=${slugify(city_2_name)}`;
        if ((!city_name && !city_2_name) && state_name.length) placeQueryData += `&state_name=${slugify(state_name)}`;
    }else{
        placeQueryData+= !!filteredFormattedAddressDataStr ? `&${filteredFormattedAddressDataStr}` : '';
    }

    /**
     * *********Range Max********
     *  Day & PU :   30 in case City || 5  in case Locality
     *  PreSchool : 10 in case City || 5  in case Locality
     *  Boarding : 100 in case Locality || City Both
     *  Start
     * */

    let localityStr = getCleanLocality(formatted_address, city_name, city_2_name, state_name);

    let distanceRangeMax = '';

    /*if ([1, 5].includes(parseInt(type)) && localityStr) { // update range slider in case of city id
        distanceRangeMax = 5;
    }
    if (!!city_name.length && [1, 5].includes(parseInt(type)) && !localityStr) { // update range slider in case of city id
        distanceRangeMax = 30;
    }

    if ([2].includes(parseInt(type)) && localityStr) { // update range slider in case of city id
        distanceRangeMax = 5;
    }
    if (!!city_name.length && [2].includes(parseInt(type)) && !localityStr) { // update range slider in case of city id
        distanceRangeMax = 10;
    }

    if ([3].includes(parseInt(type)) && localityStr) { // update range slider in case of city id
        distanceRangeMax = 100;
    }
    if (!!city_name.length && [3].includes(parseInt(type))) { // update range slider in case of city id
        distanceRangeMax = 100;
    }

    if (distanceRangeMax && !regions.length) placeQueryData += `&range_max=${distanceRangeMax}`;*/

    /**
     * *********Range Max*******
     * END
     **/

    let URL = APP_URL;
    URL += `/search/${getSchoolTypeName(type)}/${address}${searchQueryPath}?${DayFeeFilter.length ? DayFeeFilter : ''}${placeQueryData.length ? placeQueryData : ''}`;
    // console.log(`${URL}&sort_vad=1&bp=ch`);
    window.location.href = `${URL}&sort_vad=1&bp=ch`;

}

window.AssistLoginHideShow = () => {
    if (user) {
        $('#assist-login-form .assist-login-form-wrapper').hide();
        $('#submitAssitant').text('Get my options');
    }

}

window.checkSmartSearchLogin = () => {
    if (user) {
        getUserAssistantDetails();
        $('#AssistantModal').modal('show');
    } else $('#AssistantModal').modal('show');

}

window.getCityStateDataByAddress = (address) => {

    mainApiAxios.get(`/common/cities/server/routes/api_get_city_state_by_address.php?formattedAddress=${address}`).then(res => {
        getCityStateDataByAddressData = res.data;
    }).catch(err => console.log(err));

    /*$.ajax({
        type: "GET",
        url: `${HOST}/common/cities/server/routes/api_get_city_state_by_address.php`, /!* users/user_track/user_track_insert.php replaced *!/
        data: {
            'formattedAddress': address
        },
        success: function(data){
            getCityStateDataByAddressData = data;
            return false;
        }
    });*/
}

window.getUserAssistantDetails = () => {
    mainApiAxios.post('/assistant-details').then(res => {
        const assistData = res.data;
        AssistLoginHideShow();
        // $('.button_1O').hide();

        $('#preferred-latitude').val(assistData.lead_lat);
        $('#preferred-longitude').val(assistData.lead_lng);

        assistantUserData = assistData;

        // if(!!assistantUserData.lead_location) getCityStateDataByAddress(assistantUserData.lead_location);

        // singleGrade();

        if (!assistData) {
            return false;
        } else {
            // debugger;
            AssistUserSchoolType(assistData.lead_school_type);

            if (assistData.lead_school_type === 1) {
                if (assistData.child_1_grade !== "") AssistUserGrade(assistData.child_1_grade);
                if (assistData.child1_board !== "") AssistUserBoard(assistData.child1_board);
                if (assistData.lead_fees !== "") AssistUserfees(assistData.lead_fees);

                // AssistUserDayQueryText();
                locality(assistData.lead_location);
                // getNotification(assistData.notification);

            } else if (assistData.lead_school_type === 5) {

                if (assistData.child_1_grade !== "") AssistUserGrade(assistData.child_1_grade);
                if (assistData.child1_board !== "") AssistUserBoard(assistData.child1_board);
                if (assistData.lead_fees !== "") AssistUserfees(assistData.lead_fees);

                AssistUserPuQueryText();
                locality(assistData.lead_location);
                // getNotification(assistData.notification);

            } else if (assistData.lead_school_type === 2) {

                AssistUserAge(assistData.child_1_dob);
                if (assistData.lead_fees !== "") {
                    AssistUserfees(assistData.lead_fees);
                }
                AssistUserPreQueryText();
                locality(assistData.lead_location);
                // getNotification(assistData.notification);

            } else if (assistData.lead_school_type === 3) {

                if (assistData.child_1_grade !== "") AssistUserGrade(assistData.child_1_grade);
                if (assistData.child1_board !== "") AssistUserBoard(assistData.child1_board);
                if (assistData.lead_fees !== "") AssistUserfees(assistData.lead_fees);
                if (assistData.child1_region !== "") AssistUserRegion(assistData.child1_region);

                AssistUserBoardingQueryText();
                locality(assistData.lead_location);
                getGender(assistData.child_1_gender);
                // getNotification(assistData.notification);

            }
        }

    }).catch(err => console.log(err));
}

window.getCoedTypeName = (id) => {

    let coed = "";
    switch (id) {
        case "1":
            coed = "coed";
            break;
        case "2":
            coed = "girls";
            break;
        case "3":
            coed = "boys";
            break;
    }
    return coed;
}

window.getSchoolTypeName = ($schoolType) => {
    $schoolType = parseInt($schoolType);

    switch ($schoolType) {
        case  1 :
            return 'day-school-k12';
        case 2 :
            return 'earlyage-preschool';
        case 3 :
            return 'boarding-school';
        case 5:
            return 'pu-junior-colleges';
        case 4:
            return 'day-care';
        case 6:
            return 'online-school';
    }
}

window.inputNumberLength = (e) => {
    const { value, maxLength } = e.target;
    if (value > maxLength) {
        e.target.value = e.target.value.slice(0, maxLength);
    }
};

window.checkCityExistsInStates = (cityName) => {
    return getAllStates.filter((stateObj, i) => {
        let stateName = stateObj.name.toLowerCase();
        if(stateName === cityName && cityName!== 'delhi') {
            return true;
        }
    });
}

window.AssistantAnalyticsDaySchool = () => {
    ga('send', 'event', {
        eventCategory: 'Assistant',
        eventAction: 'Day School Assistant Submitted',
        eventLabel: 'Day school Assistant Submitted'
    });
}

window.AssistantAnalyticsPreSchool = () => {
    ga('send', 'event', {
        eventCategory: 'Assistant',
        eventAction: 'Pre School Assistant Submitted',
        eventLabel: 'Pre school Assistant Submitted'
    });
}

window.AssistantAnalyticsSubmitted = () => {
    ga('send', 'event', {
        eventCategory: 'Assistant',
        eventAction: 'Assistant Submitted',
        eventLabel: 'Assistant Submitted'
    });
}

window.showLoaderCoverAssist = () => {
    $('#cover-spin-assist').show();
}

window.hideLoaderCoverAssist = () => {
    $('#cover-spin-assist').hide();
}

window.getCleanLocality = (formatted_address,city,city2,state,country='india') => {
    return formatted_address.replace(new RegExp(city2, "gi"), '')
        .replace(new RegExp(city, "gi"), '')
        .replace(new RegExp(state, "gi"), '')
        .replace(new RegExp(country, "gi"), '')
        .replace( new RegExp('-', "gi"), '')
        .replace( new RegExp(' ', "gi"), '')
        .replace( new RegExp(',', "gi"), '');
}

window.getBoardName = (id) => {

    let board = "";
    switch (id) {
        case "1":
            board = "cbse";
            break;
        case "2":
            board = "icse-isc";
            break;
        case "3":
            board = "ib";
            break;
        case "4":
            board = "Others";
            break;
        case "6":
            board = "igcse";
            break;
    }

    return board;
}

window.validateFormLoginAssist = (type) => {
    if (type === "submit") {
        const email = $('#assist-login-email').val();
        if (assistLoginForm.find("#assist_login_otp").length > 0) {
            return !!(assistantLoginPhone.val() && $('#assist_login_name').val() && $('#assist_login_otp').val());
        } else return !!(assistantLoginPhone.val() && $('#assist_login_name').val() && (!email || validateEmail(email)));
    } else if (type === "resend") return !!(assistantLoginPhone.val() && $('#assist_login_name').val());
    else return false;
}

window.validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

window.AssistSchoolTypeRegisterAnalytics = (schoolType = 0) => {
    if (schoolType === 1) {
        ga('send', 'event', {
            eventCategory: 'Assistant', eventAction: 'Assistant Day School Register Success',
            eventLabel: 'Assistant Day School Register Successfully'
        });
    } else if (schoolType === 2) {
        ga('send', 'event', {
            eventCategory: 'Assistant', eventAction: 'Assistant Play School Register Success',
            eventLabel: 'Assistant Play School Register Successfully'
        });
    } else if (schoolType === 3 || schoolType === 4) {
        ga('send', 'event', {
            eventCategory: 'Assistant', eventAction: 'Assistant Boarding School Register Success',
            eventLabel: 'Assistant Boarding School Register Successfully'
        });
    }
}

window.AssistPhoneLogin = (background = false, recaptcha_token = null) => {

    // const Assist_ISD_CODE = $('#assist_countryCode .current-isdcode').text().trim().replace('+', '');
    const Assist_ISD_CODE = $('#assist-login-form .iti__selected-dial-code').text().trim().replace('+', '');
    let user_name = $('#assist_login_name').val();
    let AssistMobNo = assistantLoginPhone.val().replace(/\s+/g, '');

    ga('send', 'event', {
        eventCategory: 'Total Signup', eventAction: ' user_registration', eventLabel: ' user_registration'
    });

    if (AssistMobNo.split('')[0] === "0") AssistMobNo = AssistMobNo.replace('0', '');

    if (Assist_ISD_CODE === '91' && AssistMobNo.length > 10) {
        if (AssistMobNo.slice(0, 2) === '91') AssistMobNo = AssistMobNo.replace('91', '');
    }

    // let phone = Assist_ISD_CODE === '91' ? AssistMobNo : `${Assist_ISD_CODE}-${AssistMobNo}`;
    let phone = AssistMobNo;

    let rndId = Cookies.get("userRandomIdentifier");

    const params = {
        name: user_name,
        identifier: AssistMobNo,
        country_code: Assist_ISD_CODE,
        role: 1,
        email: $('#assist-login-email').val(),
        // g_recaptcha_response: recaptcha_token,
        // randomId: rndId
    };

    // showLoginBtnSpin();
    submitAssistant.addClass('pointer-events-none');
    mainApiAxios.post(`/request-otp`, params).then(function (res) {
        // debugger;
        let response = res.data;
        if (DEBUG) console.log('login', response);
        let otpElmAssist = $(`<label for="">One Time Password</label>
                                <div id="otp-container" class="d-flex align-items-center">
                                <div class="otp-input-wrapper d-flex justify-content-start digit-group">
                                <input id="assist_login_otp" name="login_otp" class="form-control" type="hidden" placeholder="Enter OTP" >
                                <input class="otp-input form-control" type="number" data-tabsequence="1" placeholder="X" maxlength="1">
                                <input class="otp-input form-control" type="number" data-tabsequence="2" placeholder="X" maxlength="1">
                                <input class="otp-input form-control" type="number" data-tabsequence="3" placeholder="X" maxlength="1">
                                <input class="otp-input form-control" type="number" data-tabsequence="4" placeholder="X" maxlength="1">
                                </div>
                                <a href="javascript:void()" class="resend-otp-btn resend_otp" onclick="resendOtp(event)">Resend</a>
                                </div>
                                <div class="assistant-error assistant-otp-error error-text"></div>`);

        /*	change login button name	*/
        submitAssistant.removeClass('pointer-events-none')
            .text('Get my options')
            .css('width','100%'); //if text change please check assistant.js with contains() function
        $('#prev-nav').hide();
        // submitAssistant.css('width','100%');


        if (response.code === 'OK') {
            // assistHideLoginBtnSpin();
            $('.auth-error').text('');

            // localStorage.setItem('user_type', response.data.code);

            if (assistLoginForm.find("#assist_login_otp").length === 0)
                // otpElmAssist.insertAfter($('#assist-login-form .main_login'));
                $('#assist-login-form .main_login').append(otpElmAssist);

            const user = response.detail_log.user;

            let resendOtp = $('.resend_otp');
            resendOtp.text('OTP Sent Successfully').addClass('text-success pointer-events-none');
            setTimeout(function(){
                resendOtp.text('Resend').removeClass('text-success pointer-events-none');
            }, 5000);

            if(!! user.id) sendNewUnverifiedUserNotificationEmail(user.id);

        } else {
            $('.auth-error').text(response.data.msg || 'An unknown error occurred.').show();
            submitAssistant.removeClass('pointer-events-none');
            // assistHideLoginBtnSpin();
        }
        grecaptcha.reset(grecaptchaWidgetId2);
    }).catch(err => {
        // console.log(err.response.data, 'assistant');
        $('.auth-error').text(err.response.data.msg || 'An unknown error occurred.').show();
    });
}

window.encode_decode = (params = {}) => {
    let formatObj;
    // console.log({params});
    if (params['latitude'] && params['latitude'] !== "" && params['longitude'] && params['longitude'] !== "") {
        let latLngStr = params['latitude'] + ',' + params['longitude'];
        formatObj = {data: {'latlng': window.btoa(latLngStr)}, 'error': ''};
    } else formatObj = {data: {}, error: 'Error!!'};

    return formatObj;
}

window.AssistVerifyUser = () => {
    // let self = this;
    // const ISD_CODE = $('#assist_countryCode .current-isdcode').text().trim().replace('+', '');
    const ISD_CODE = $('#assist-login-form .iti__selected-dial-code').text().trim().replace('+', '');
    let AssistMobNo = assistantLoginPhone.val().replace(/ /g, '');
    if (AssistMobNo.split('')[0] === "0") AssistMobNo = AssistMobNo.replace('0', '');

    if (ISD_CODE === '91' && AssistMobNo.length > 10) {
        if (AssistMobNo.slice(0, 2) === '91') AssistMobNo = AssistMobNo.replace('91', '');
    }
    // let phone = ISD_CODE === '91' ? AssistMobNo : ISD_CODE + "-" + AssistMobNo;
    let phone = AssistMobNo;

    let name = $('#assist_login_name').val();

    let otp = $('#assist_login_otp').val();

    let rndId = Cookies.get("userRandomIdentifier");

    const params = {
        identifier: AssistMobNo,
        country_code: ISD_CODE,
        role: 1,
        otp: otp,
        name: name,
        assistant: 1,

    };
    // showLoginBtnSpin();
    mainApiAxios.post(`/verify-otp`, params)
        .then(function (res) {
            // debugger;
            let response = res.data;
            if (DEBUG) console.log('login', response);
            if (response.code === 'OK') {
                // if (typeof (self.schoolType) === 'undefined') self.schoolType = '';
                if (DEBUG) console.log('verified', response);
                AssistLoginSuccess(response);
                // if (pageType && pageType === 'DETAILS-PAGE') sendVadNotificationProcessing();
                ga('send', 'event', {
                    eventCategory: 'Total Signup', eventAction: 'user_verified', eventLabel: 'user_verified'
                });

                ga('send', 'event', {
                    eventCategory: 'Assistant', eventAction: 'Assistant Register Success',
                    eventLabel: 'Assistant Register Successfully',
                    eventValue: schoolType
                });

                AssistSchoolTypeRegisterAnalytics(schoolType);
                // assistHideLoginBtnSpin();
                loginSuccessAssist();
                AssistFinish();
                /*	Register Google Analytics Code	*/

            } else if (response.code === 'E_UNAUTHORIZED') {
                $('.error-text').text('Incorrect OTP').show();
                // assistHideLoginBtnSpin();
            } else {
                $('.error-text').text('An unknown error occurred.').show();
                // assistHideLoginBtnSpin();
            }
        }).catch(err => {
            $('.error-text').text(err.response.data.msg || 'An unknown error occurred.').show();
    });
}

window.AssistLoginSuccess = (data) => {
    // debugger;
    user = data.detail_log.user;
    // const payload = jwt_decode(data.jwt.access_token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('access_token', data.jwt.access_token);
    Cookies.set('access_token_parent', data.jwt.access_token, {domain: DOMAIN_NAME, expires: 30});

    authInit();

    if (user.role.role === 'PARENT') {
        updateEventUserId();
        loginSuccessAssist();

        sendNewVerifiedUserNotificationEmail();

    } else {
        $('.auth-error').text('Invalid user type. Please contact our tech. Support').show();
        logout();
        // assist_logout();
    }
}

window.assist_logout = () => {
    /*	clear token remove user from local storage to log user out	*/
    document.getElementById("login-form").reset();
    if (document.getElementById("otp-container")) document.getElementById("otp-container").remove();
    if (document.getElementById("resend-otp-container"))
        document.getElementById("resend-otp-container").remove();

    access_token = null;
    requestOptions = null;
    user = null;
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    Cookies.remove('access_token_parent', {domain: '.edustoke.com'});
    /*	Google Analytics for Logout User	*/
    ga('send', 'event', {eventCategory: 'Login/Signup', eventAction: 'Logout', eventLabel: 'logout Successfully'});

    // assistSetLoginData();
    // assist_auth_ui_update();

    //todo reset jwt on server side
}

window.assistSetLoginData = () => {
    if (localStorage.getItem('user_login_data')) {
        let user_login_data = JSON.parse(localStorage.getItem('user_login_data'));
        let user_phn = user_login_data.phone;
        $('#assist_login_name').val(user_login_data.name);
        assistantLoginPhone.val(user_phn.slice(user_phn.lastIndexOf('-') + 1, user_phn.length));
        // $(`#country-code li[data-isdcode="+${user_phn.slice(0, user_phn.indexOf('-'))}"] a`).click();
    }
}

window.loginSuccessAssist = () => {
    submitAssistant.css('pointer-events','none').html(`Loading <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>`);
    // $('#assistLogin').hide();
    // $('#MobileText').show();
    if (user) $('.mobile').html(user.phone);
}

/*window.assist_updateEventUserId = () => {
    if (!Cookies.get('userRandomIdentifier') || !user) return;
    $.ajax({
        type: "POST",
        url: `${HOST}/events/update_event_userId.php`,
        cache: false,
        data: {random_userId: Cookies.get('userRandomIdentifier'), client_ip: getSearchParams('client_ip')},
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        },
        success: (response) => {
            if (DEBUG) console.log(response);
        }
    });
}*/

window.assist_auth_ui_update = () => {
    $('#profile-page').find('a').attr('href', `${DASHBOARD_HOST}parent/info`);
    $('#login_register_btn').attr('href', `${DASHBOARD_HOST}parent/auth/register`);

    $('#loginModal').modal('hide');
    if (user) {
        $('.loginUserProfileBlock').show();
        $('.loginBtnBlock').hide();
        if (mobileCheck()) $('#shortlistHeaderHeartIcon').show(); /*	heart icon header show	*/
        $('#btn-profile').show();
        $('#OfferMob').show();
        shortListElm.show();
        $('#btn-auth').hide();
        $('#CheckShortlistFixedButton').show();
        if (typeof resetChatLoginUI !== 'undefined') resetChatLoginUI();
    } else {
        $('.loginUserProfileBlock').hide(); /*	login profile icon hide	*/
        $('.loginBtnBlock').show(); /*	login btn block hide	*/
        $('#shortlistHeaderHeartIcon').hide(); /*	heart icon hide	*/
        $('#btn-profile').hide();
        shortListElm.hide();
        $('#OfferMob').hide();
        $('#wishlist-container').hide();
        $('#btn-auth').show();
        $('#CheckShortlistFixedButton').hide();
    }
}

window.assistFeeSliderHTML = () => {
    return `<p>You can either select fees range</p>
                    <div class="assist-fee-slider-container">
                        <input type="text" class="assist-fee-slider" name="assist-fee-slider">
                    </div>`
}

window.resendOtp = (event) => {
    event.preventDefault();
    let loginFormErrorElm = $('.login-form-error');
    let assistLoginEmailElm = $('#assist-login-email');
    if (validateFormLoginAssist('resend')) {
        loginFormErrorElm.empty();
        // showLoginBtnSpin();
        grecaptcha.execute(grecaptchaWidgetId2);
    } else {
        if (!loginFormErrorElm.html()) {
            if (!$('#assist_login_name').val()) loginFormErrorElm.append("Name is required.<br/>");
            if (!$('#assist_login_phone').val()) loginFormErrorElm.append("Phone number is required.<br/>");
            if (assistLoginEmailElm.val() && !validateEmail(assistLoginEmailElm.val())) loginFormErrorElm
                .append("Please enter a valid email.<br/>");
        }
    }
}

$(document).ready(function () {
    let stepsCount = $('.step-assistant').length - 1;
    let stepNum = 0;


    // $('#assistantModal').modal('show');

    $("#progress-count").html(`0 of ${stepsCount}`);

    /* ---------------------- assistant prev button ---------------------- */
    $("#prev-nav").on('click', function () {
        if (user) $('#get_in_touch').hide();
        if (stepNum > 0) {
            stepNum -= 1;
            let assistantStep = $(`#assistant-step-${stepNum}`);
            $(".step-assistant").removeClass('active');
            assistantStep.addClass('active');
            let percent = (stepNum / stepsCount) * 100;
            $("#assistant-progress").css("width", percent + "%");
            if (!assistantStep.hasClass('login-step')) {
                submitAssistant.hide();
                $('#next-nav').show();
            }

            $("#progress-count").html(stepNum + " of " + stepsCount);
        }
        if ($('#assistant-step-0').hasClass('active')) {
            $('#prev-nav').addClass('d-none');
        }
    });
    /* ---------------------- /assistant prev button ---------------------- */

    /* ---------------------- assistant next button ---------------------- */
    $("#next-nav").on('click', function () {
        const assistFeeSlider = $('.assist-fee-slider').data("ionRangeSlider");

        // console.log(assistFeeSlider.old_from, assistFeeSlider.old_to)

        if (user) $('#get_in_touch').hide();

        $('#prev-nav').removeClass('d-none');
        if ($('#assistant-step-0').hasClass('active')) {
            if (!(parentData.school_type)) {
                console.log('Select A School');
                return;
            }
        }
        if ($('.step-assistant.active').hasClass('dynamic-step')) {
            let checkData = $(".step-assistant.active").attr("data-step-type");

            if (parentData[checkData].length === 0) {
                if(checkData !== 'fees') {
                    $('.step-assistant.active .disclaimer').show();
                    return;
                }
                if(checkData === 'fees') {
                    if(assistFeeSlider.old_from <= 500 && assistFeeSlider.old_to <= 500){
                        $('.step-assistant.active .disclaimer').show();
                        return;
                    }
                }
            }
        }
        if ($('.final-step').hasClass('active') && $("#submitAssitant:contains('options')")) {
            $('#prev-nav').hide();
            submitAssistant.css('width', '100%');
        }

        let gradeHeader = '';
        let feesHeader = '';
        let boardHeader = '';
        let regionHeader = '';
        let ageHeader = '';

        if (parentData['grade'].length !== 0) {
            gradeHeader = ' for grade <span class="selected-tag">' + parentData['grade'] + '</span>';
        }
        if (parentData['fees'].length !== 0) {
            feesHeader = ` in the fee range <span class="selected-tag"> ${assistFeeSlider.result.from_pretty} - ${assistFeeSlider.result.to_pretty} </span>`;
        }
        if (parentData['board'].length !== 0) {
            boardHeader = ' with <span class="selected-tag">' + parentData['board'].join() + '</span>';
        }
        if (parentData['region'].length !== 0) {
            regionHeader = ' in <span class="selected-tag">' + parentData['region'].join() + ' region</span>';
        }
        if (parentData['age'].length !== 0) {
            ageHeader = ' for age group <span class="selected-tag">' + parentData['age'] + '</span>';
        }

        let extraHeader = gradeHeader + feesHeader + boardHeader + regionHeader + ageHeader;

        $('.extra-heading').html(extraHeader);

        if (stepNum < stepsCount) {
            stepNum += 1;
            $(".step-assistant").removeClass('active');
            $("#assistant-step-" + stepNum).addClass('active');
            if ($('#assistant-step-' + stepNum).hasClass('login-step')) {
                submitAssistant.show();
                $('#next-nav').hide();
            }
            let percent = (stepNum / stepsCount) * 100;
            $("#assistant-progress").css("width", percent + "%");
            $("#progress-count").html(stepNum + " of " + stepsCount);
        }

        Object.entries(parentData).forEach(([key, val]) => {
            // console.log(key, 'key');
            if (val.length === 0) {
                $('#selector-' + key).hide();
            } else if (val.length !== 0 && Array.isArray(val)) {
                let displayData = '';
                val.forEach(element => {
                    displayData += '<span>' + element + '</span>';
                });
                $('#selector-' + key + ' .selector-info').html(displayData);
                $('#selector-' + key).show();
            } else {
                $('#selector-' + key + ' .selector-info').html("<span class='text-capitalize' >" + val + "</span>");
                $('#selector-' + key).show();
            }

            if(key === 'fees'){
                $('#selector-' + key + ' .selector-info').html(`<span class='text-capitalize' >${assistFeeSlider.result.from_pretty} - ${assistFeeSlider.result.to_pretty}</span>`);
                $('#selector-' + key).show();
            }

        });

    });
    /* ---------------------- assistant next button ---------------------- */

    /* ---------------------- select school type ---------------------- */
    $(".school-selector").on('click', function (e) {
        let assistantSchoolType = $(this).attr("data-schooltype");
        let assistantSchoolTypeId = parseInt($(this).attr("data-schooltypeid"));
        let stepAddCount = 0;

        $(".school-selector").removeClass('selected');
        $(this).addClass('selected');

        if (assistantSchoolTypeId === 3) {
            $('.preferred-location-hide').removeClass('d-flex').addClass('d-none');
            $('.assistant-gender').removeClass('d-none').addClass('d-flex');
            $('.preferred-location-form').addClass('preferred-location-day');
        } else {
            $('.preferred-location-hide').removeClass('d-none').addClass('d-flex');
            $('.assistant-gender').addClass('d-none').removeClass('d-flex');
            $('.preferred-location-form').removeClass('preferred-location-day');
        }

        parentData.school_type = assistantSchoolType;

/*        parentData = {
            "school_type": assistantSchoolType,
            "grade": "",
            "fees": [],
            "board": [],
            "region": [],
            "age": ""
        };*/

        $("div").remove(".dynamic-step");

        Object.entries(stepJson[assistantSchoolType]).forEach(([key, schoolOptions]) => {

            let headingSub = '';
            let assistantSelector = '';
            if (key === 'grade') {
                headingSub = 'Which class do you want admission in?';

            } else if (key === 'fees') {
                headingSub = 'What is the ' + ((assistantSchoolType === 'pre') ? 'monthly' : 'annual') + ' fee range you are looking for?';
            } else if (key === 'board') {
                headingSub = 'What is your preference for the Board?';
            } else if (key === 'region') {
                headingSub = 'What is your preferred location?';
            } else if (key === 'age') {
                headingSub = 'What is preferred age bracket?';
            }

            for (let option in schoolOptions) {
                assistantSelector += `<span type="button"
																							class="assistant-tag"
																							data-tag-wrapper="${key}"
																							data-assistant-tag="${option}"
																							data-filter="${schoolOptions[option][1]}"
																							data-id="${schoolOptions[option][0]}">${(key === 'grade') ? option.replace('Class ', '') : option}</span>`;
            }


            $("#assistant-step-" + stepAddCount).after(
                `<div id="assistant-step-${stepAddCount + 1}" class="step-assistant dynamic-step" data-step-type="${key}">
									<div class="bottom d-flex flex-column align-items-center">
										<div class="questionnaire text-center">
											<h2>You are looking for admission in a
												<span class="text-capitalize selected-tag">${((assistantSchoolType === 'pu') ? "PU College" : assistantSchoolType + " School")}</span>
												<span class="extra-heading"></span>
											${headingSub}
											</h2>
                                            ${(key === 'fees') ? assistFeeSliderHTML() : ''}
											<p>${((key === "grade" || key === "age") ? "Select any one" : "You can select multiple")}</p>
										</div>
										<div class="cards d-flex">
											<div class="assistant-selector assistant-${key}-wrapper">${assistantSelector}</div>
										</div>
										<div class="disclaimer" style="display: none">
											<p>${(key === 'fees') ? 'Disclaimer : Please Select range Slider or at least one fee range.': 'Disclaimer : Please Select at least one.'}</p>
										</div>
									</div>
								</div>`
            );

                const assistFeeSlider = $('.assist-fee-slider');
            if(!assistFeeSlider.hasClass('irs-hidden-input')){
                assistFeeSlider.ionRangeSlider({
                    type: "double",
                    skin: 'round',
                    drag_interval: true,
                    min_interval: null,
                    max_interval: null,
                    step: 1000,
                    prettify: function(num){
                        let numberLength = num.toString().length;
                        if(numberLength > 3 && numberLength < 6){
                            num =( num/1000)
                            if((num % 2) !== 0) num = num.toFixed(1);
                            num += 'K';
                        }else if(numberLength > 5){
                            num = num/100000;
                            if((num > 1) && (num % 2) !== 0) num = num.toFixed(2);
                            num+='Lac';
                        }
                        return num;
                    },
                    onFinish: function(data){
                        $('#assistant-step-2 .assistant-tag').removeClass('selected');
                    }
                });
            }

            if(assistFeeSlider.hasClass('irs-hidden-input')){
                let feeBandWrapper = $('#assistant-step-2 .assistant-tag');
                let feeBands = [];
                let min = 0;
                let max = 0;

                feeBandWrapper.map((i, feeBand) => {
                    feeBands.push(...$(feeBand).attr('data-filter').split("-"));
                });
                min = Math.min(...feeBands);
                max = Math.max(...feeBands);
                assistFeeSlider.data("ionRangeSlider").update({min, max});
            }

            $(".final-step").attr("id", "assistant-step-" + (stepAddCount + 2));
            $(".login-step").attr("id", "assistant-step-" + (stepAddCount + 3));

            stepsCount = $('.step-assistant').length - 1;
            $("#progress-count").html("0 of " + stepsCount);
            stepAddCount++;
        });
    });
    /* ---------------------- /select school type ---------------------- */

    /* ---------------------- dynamic steps by selected school type ---------------------- */
    $("body").on('click', '.assistant-tag', function () {
        let assistantTag = $(this);
        $('.step-assistant.active .disclaimer').hide();
        let stepType = assistantTag.attr('data-tag-wrapper');

        if (stepType === "grade" || stepType === "age") {
            $('.dynamic-step.active .assistant-tag').removeClass('selected');
            assistantTag.addClass('selected');
            if (!!stepType) parentData[stepType] = assistantTag.attr("data-assistant-tag");

        } else {
            assistantTag.toggleClass('selected');
            let selectData = assistantTag.attr("data-assistant-tag");
            let feeBands = assistantTag.attr('data-filter');
            if (assistantTag.hasClass("selected")) {
                if (!!stepType) parentData[stepType].push(selectData);
                if(stepType === 'fees') parentData.fee_range.push(feeBands);

            } else {
                let indexSelectData = parentData[stepType].indexOf(selectData);
                if (!!stepType) parentData[stepType].splice(indexSelectData, 1);

                // for range slider
                if(stepType === 'fees'){
                    let indexSelectData = parentData.fee_range.indexOf(feeBands);
                    parentData.fee_range.splice(indexSelectData, 1);
                }
            }

            if(stepType === 'fees'){
                let feeBands = [], min = 0, max = 0;
                if(parentData.fee_range.length) {
                    parentData.fee_range.map(fee => feeBands.push(...fee.split('-')));
                    min = Math.min(...feeBands);
                    max = Math.max(...feeBands);
                    const assistFeeSlider = $('.assist-fee-slider');
                    assistFeeSlider.data("ionRangeSlider").update({from: min, to: max});
                }
            }
        }
    });
    /* ---------------------- dynamic steps by selected school type ---------------------- */

    /* ---------------------- mobile phone input ---------------------- */

    $('#AssistantModal').on('show.bs.modal', () => {

        if (assistantLoginPhone.parent('.iti').length === 0) {
            assistantLoginPhone.intlTelInput(defaultIntlTelInput);
        }

    });

    /* ---------------------- /mobile phone input ---------------------- */

    /* ---------------------- submit assistant form ---------------------- */
    $('#submitAssistant').on('click', function (e) {
        // debugger;
        if (user) {
            AssistFinish();
        } else {
            assistLoginForm.trigger('submit');
        }
    });
    /* ---------------------- /submit assistant form ---------------------- */

    /* ---------------------- otp input events ---------------------- */
    let assistOtpInputs = '#otp-container input[type=number]';
    bodySelector.on('input', assistOtpInputs, function (event) {
        inputNumberLength(event)
    });

    bodySelector.on('keyup', assistOtpInputs, function (event) {
        let currentInput = $(this);
        let allOtpInput = $('#assist-login-form .otp-input-wrapper input[type=number]');
        let val = currentInput.attr('data-tabsequence');

        assistantOtpError.text('');

        if (allOtpInput[val - 1].value !== '' && val < 4) {
            allOtpInput[val].focus()
        } else if (allOtpInput[val - 1].value === '' && val > 1) {
            allOtpInput[val - 2].focus()
        }

        let otp1 = allOtpInput.eq(0).val();
        let otp2 = allOtpInput.eq(1).val();
        let otp3 = allOtpInput.eq(2).val();
        let otp4 = allOtpInput.eq(3).val();

        let otpStr = '';
        if (!!otp1) otpStr += otp1;
        if (!!otp2) otpStr += otp2;
        if (!!otp3) otpStr += otp3;
        if (!!otp4) otpStr += otp4;

        $('#assist_login_otp').val(otpStr);

    });
    /* ---------------------- /otp input events ---------------------- */

    assistLoginForm.off().on('submit', function (event) {
        // debugger;
        event.preventDefault();

        // let loginFormErrorElm = $(".login-form-error");
        let assistLoginEmailElm = $("#assist-login-email");

        // loginFormErrorElm.empty();
        assistantNameError.empty();
        assistantPhoneError.empty();
        assistantOtpError.empty();
        assistantEmailError.empty();
        assistantLoginName.css('border-color','#9b9b9b');
        assistantLoginPhone.css('border-color','#9b9b9b');
        assistLoginEmailElm.css('border-color','#9b9b9b');

        location_type = 'PREF';

        const preferredLocality = $('#preferred-locality');

        if (validateFormLoginAssist('submit')) {
            // showLoginBtnSpin();

            if(!preferredLocality.val()){
                $('#localityError').text('Location is required');
                preferredLocality.css('border-color','red');
                return false;
            }else{
                $('#localityError').text('');
                preferredLocality.css('border-color','#9b9b9b');
            }

            if (assistLoginForm.find("#assist_login_otp").length === 0) grecaptcha.execute(grecaptchaWidgetId2);
            else if (assistLoginForm.find("#assist_login_otp").length > 0) AssistVerifyUser();

        } else {
            if (!assistantLoginName.val()) {
                $('.assistant-name-error').append("Name is required.");
                assistantLoginName.css('border-color','red');
            }
            if (!assistantLoginPhone.val()) {
                assistantPhoneError.append("Phone number is required.<br/>");
                assistantLoginPhone.css('border-color','red');
            }

            if (assistLoginForm.find("#assist_login_otp").length > 0 && !$('#assist_login_otp').val()) {
                assistantOtpError.append("OTP is required.<br/>");
            }

            if ((assistLoginEmailElm.val() && !validateEmail(assistLoginEmailElm.val())) || !assistLoginEmailElm.val()) {
                assistantEmailError.append("Please enter a valid email.<br/>");
                assistLoginEmailElm.css('border-color','red');
            }

        }
    });


});
